/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import EventCard from '/client/src/components/eventCard';

type GridType1PropsType = {
  eventList: [],
  collaboratorsList: [],
  transactionsList: []
};

const GridType1 = ({ eventList, collaboratorsList, transactionsList }: GridType1PropsType): React.Element<'div'> => {
  return (
    <div className="row GridType1-row">
      <EventCard type='new-event' />

      {
        _.map(eventList, (ev: {}, evi: number): React.Element => {
          let _collaboratorsList = [];

          _.forEach(collaboratorsList, (ci: {}): [] => {
            if (_.toString(ci.event_id) === _.toString(ev.id)) {
              _collaboratorsList = ci.collaborators;
            }
          });

          const transactions = _.find(
            transactionsList, (ti: {}): {} => (_.toString(ti.event_id) === _.toString(ev.id))
          );

          return (
            <EventCard
              {...ev}
              key={`EventCard-${evi}`}
              collaboratorsList={_.compact(_collaboratorsList)}
              transactions={transactions}
            />
          );
        })
      }
    </div>
  );
};

export default GridType1;
